export const GEAR_VIEW_LABELS = {
    'all-items': 'All items',
    'my-items': 'My items',
    'unassigned-members': 'Unassigned · members',
    'unassigned-location': 'Unassigned · location',
    'needs-action': 'Needs action',
    'low-stock': 'Low stock'
};
